import { useEffect, useState } from "react";
import axios from "axios";
import ErrorAdd from "../../../util/ErrorAdd";
import CompanyChange from "../../../components/global/CompanyChange";
import ButtonAdd from "../../../components/global/ButtonAdd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import ModalApi from "./ModalApi";

function BlockApi() {

    useEffect(() => {
        if (dataList.loaded === false) {
            list();
        }
    }, []);

    const [modalEditShow, setModalEditShow] = useState(false);
    const [data, setData] = useState(null);



    const [loadingList, setLoadingList] = useState(false);
    const [logList, setLogList] = useState(null);
    const [dataList, setDataList] = useState({ loaded: false, data: [] });

    function list() {
        setLoadingList(true);
        setLogList(null);

        axios.get('/api_main/company/userServiceApiList', { params: { ID_Service: process.env.REACT_APP_ID_SERVICE } })
            .then((res) => {
                if (res.data.Status == 1) {
                    setDataList({ loaded: true, data: res.data.Data })
                }
                else {
                    setLogList(res.data.Error);
                }
                setLoadingList(false);
            })
            .catch((err) => {
                setLoadingList(false);
                setLogList('Неизвестная ошибка!');
                ErrorAdd(err, window.location.href);
            });
    }


    const [modalAddShow, setModalAddShow] = useState(false);
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [logAdd, setLogAdd] = useState(null);

    //Добавит ключ API
    function add(id) {
        setLoadingAdd(true);

        axios.post('/api_main/company/userServiceApiSet', { ID_Company: id, ID_Service: process.env.REACT_APP_ID_SERVICE })
            .then((res) => {
                if (res.data.Status === 1) {
                    setModalAddShow(false);
                    list();
                }
                else {
                    setLogAdd(res.data.Error);
                }
                setLoadingAdd(false);
            })
            .catch((err) => {
                setLoadingAdd(false);
                setLogAdd('Неизвестная ошибка')
                ErrorAdd(err, window.location.href);
            });
    }

    //Удалит ключ API
    function remove(id) {

        console.log(id)
        axios.post('/api_main/company/userServiceApiRemove', { ID_Company: id, ID_Service: process.env.REACT_APP_ID_SERVICE })
            .then((res) => {
                if (res.data.Status === 1) {
                    setModalEditShow(false);
                    list();
                }
                else {
                    //setLogAdd(res.data.Error);
                }
                //setLoadingAdd(false);
            })
            .catch((err) => {
                // setLoadingAdd(false);
                //setLogAdd('Неизвестная ошибка')
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            {modalAddShow === true && (
                <CompanyChange onHide={() => setModalAddShow(false)} show={modalAddShow} selected={null} changeHandler={add} log={logAdd} loading={loadingAdd} />
            )}
            {modalEditShow === true && (
                <ModalApi onHide={() => setModalEditShow(false)} show={modalEditShow} removeHandler={remove}  /*changeHandler={add}*/ log={logAdd} loading={loadingAdd} model={data} />
            )}
            <ButtonAdd name="Добавить ключ" onClick={() => setModalAddShow(true)} />

            <div>
                {loadingList === true ? (
                    <div className="loader_01 mt-30"></div>
                ) : (
                    <div>
                        {dataList.data.map((item) => (
                            <div key={item.ID_Company} className="list_item mt-15" onClick={() => { setData(item); setModalEditShow(true) }}>
                                <div className='ml-10' style={{ width: '100%' }}>
                                    <div className='title'>{item.Name_Company}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    )
}
export default BlockApi;